
/***
Process Forms
***/

jQuery(document).ready(function($){


Foundation.Abide.liveValidate = true;
Foundation.Abide.defaults.patterns['dashes_only'] = /^[0-9-]*$/;


/***************** Deal with hidden WP security input fields not having data-abide-ignore attribute ******************/
// This was a fix to ensure that the form-error fields show on form submit with errors now dealt with by building the nonce manually
if ($('[data-abide]').length) {
  if ($('input[name="_wp_http_referer"]').length) {
    $('input[name="_wp_http_referer"]').attr('data-abide-ignore','');
    $('[data-abide]').foundation('_reflow');
  }
  if ($('input[name*="nonce"]').length) {
    $('input[name*="nonce"]').attr('data-abide-ignore','');
    $('[data-abide]').foundation('_reflow');
  }
}

/***************** Form Reset Visibliity ******************/

$('.form-reset').on('click',function (e) {
  var form_id = $(this).data('form-id');
  $('#' + form_id).css('display','inherit');
  $(this).closest('.email-success').css('display','none');
});


/***************** reCaptcha Visibility ******************/

$( "#enquiry_name" ).on('focus change',function() {
  $( ".check-wrapper" ).addClass('visible');
});

/***************** Contact Form Submission ******************/

function buttonSubmitting(buttonElement) {
  buttonElement.addClass('submitting');
  buttonElement.find('span').text('Submitting');
}

function buttonResetting(buttonElement) {
  buttonElement.removeClass('submitting');
  buttonElement.find('span').text(buttonElement.data('text'));
}

$('#submit-contact-form').on("click", function(ev) {
    ev.preventDefault();
    $('#contact-form').submit();
    console.log('submit clicked');
});

$('#contact-form').on("submit", function(ev) {
   ev.preventDefault();
    console.log('submitted first');
});

$(document).on('formvalid.zf.abide','#contact-form', function(e,frm) {
    // prevent the form from submitting normally
    e.preventDefault();
    console.log('form submitted');
  //  var response = grecaptcha.getResponse(formRecaptcha); // Check recaptcha response
    var submitButton = $(this).find('#submit-contact-form');
  //  if(response.length === 0) {
  //    console.log('recaptcha not verified');
      //reCaptcha not verified
  //    $('#contact-form-wrapper').find('.check-wrapper').find('.form-error').css('display','block');
  //  } else {
      buttonSubmitting(submitButton);
      console.log('recaptcha verified');
      var enquiry_name = $(this).find("#enquiry_name").val();
      var enquiry_phone = $(this).find("#enquiry_phone").val();
      var enquiry_email = $(this).find("#enquiry_email").val();
      var enquiry_message = $(this).find("#enquiry_message").val();
      var _wpnonce = $(this).find("#nonce_contact_form").val();

      $.ajax({
           data: {action: 'ajax_enquiry_form', enquiry_name:enquiry_name,enquiry_phone:enquiry_phone,enquiry_email:enquiry_email,enquiry_message:enquiry_message,_wpnonce:_wpnonce},
           type: 'post',
           url: ajaxurl,
           dataType: 'JSON',
           success: function(data) {
           console.log(data);
           if (data['success'] != "success") {
             $('#contact-form-wrapper').find('.email-failure').fadeIn( function() {
               $(this).delay(2500).fadeOut('slow');
               buttonResetting(submitButton);
             });
           } else {
             $('#form-name-response').html(data['name'] + ' ');
             $('#contact-form').hide();
             $('#contact-form-wrapper').find('.email-success').fadeIn( function() {
             });
             $('#contact-form').find("input[type=text],input[type=email],textarea,select").val("");
             $('.input-label').removeClass('has-input');
             $('#contact-form-wrapper').find('.check-wrapper').removeClass('visible');
             buttonResetting(submitButton);
            // grecaptcha.reset(formRecaptcha);
           }
           //     alert(data); //should print out the name since you sent it along

          }
      });
  //  }
});


});
